module.exports = __webpack_public_path__ + "static/logo-711a9f11a39da51fdfa2b42c6b30c73a.svg";